export default __webpack_public_path__ + "static/media/01_Kom_flexpos.04980d96.jpg";